import {IItemContent} from "../../../typescript-library";
import React from "react";
import ReactDOM from "react-dom";
import {useTranslation} from "react-i18next";
import {SwiperWithTitleAndItems} from "./SwiperBuilder";
import {IUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";

const addToCartModalBreakpoints = {
  0: {
    slidesPerView: 2.5,
    slidesOffsetBefore: 28,
    slidesOffsetAfter: 28,
  },
  768: {
    slidesPerView: 2.5,
    slidesOffsetBefore: 40,
    slidesOffsetAfter: 40,
  },
};

export const BoughtTogetherComponent: React.FC<{items: IItemContent[]; context: IUnsafeCartContext}> = ({
  items,
  context,
}) => {
  const {t} = useTranslation();

  const breakpoints = context === null ? undefined : addToCartModalBreakpoints;

  return (
    <SwiperWithTitleAndItems
      title={t("product.customersAlsoBought")}
      items={items}
      context={context}
      breakpoints={breakpoints}
    />
  );
};

// Below PDP page
const BoughtTogetherPortal: React.FC<{items: IItemContent[]; element: HTMLElement}> = ({items, element}) => {
  return ReactDOM.createPortal(<BoughtTogetherComponent items={items} context={null} />, element);
};

export default BoughtTogetherPortal;
